export default __webpack_public_path__ + "static/media/KZ.M.06.2257.3deeb627.svg";